<template>
  <div>
    <v-spacer></v-spacer>
    <v-card class="mt-3">
      <v-card-title>
        <v-text-field v-model="search" placeholder="Search..."></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="locations.records"
        :loading="isLoading"
        :options.sync="options"
        :server-items-length="totalRecords"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100],
        }"
        :search="search"
        transition="scale-transition"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title
              ><h4 class="text-md-h4 primary--text">
                Locations
              </h4></v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="1024px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mx-2" color="secondary" small v-bind="attrs" v-on="on">Bulk Location Upload</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="text-h5">Bulk Location Upload</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <base-location-bulk-create />
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
            <v-btn color="secondary" small @click="$router.push('/admin/location/0/edit')">New Location</v-btn>
            <v-btn color="primary" small @click="exportToExcel" :loading="isExporting" class="ml-2">
              <v-icon left>mdi-download</v-icon>
              Export to Excel
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.name="{ item }">
          <h4 color="primary">
            <router-link :to="'/admin/location/' + item.id">{{ item.name }}</router-link>
          </h4>
        </template>
        <template v-slot:item.type="{ item }">
          <v-chip label small dark>{{ item.type.toUpperCase() }}</v-chip>
        </template>
        <template v-slot:item.createdByUsername="{ item }">
          <v-chip label small dark color="primary">{{
            item.createdByUsername ? item.createdByUsername.toUpperCase() : 'User missing or deleted'
          }}</v-chip>
        </template>
        <template v-slot:item.location="{ item }">
          <a
            v-if="getGoogleMapsUrl(item)"
            :href="getGoogleMapsUrl(item)"
            target="_blank"
            rel="noopener noreferrer"
            class="coordinates-link"
          >
            <v-icon x-small color="primary" class="mr-1">mdi-map-marker</v-icon>
            {{ formatCoordinates(item) }}
          </a>
          <span v-else>Not specified</span>
        </template>
        <template v-slot:item.createdAt="{ item }">
          <h5 color="primary">{{ item.createdAt | getFormattedDate }}</h5>
        </template>
        <template v-slot:item.updatedAt="{ item }">
          <h5 color="primary">{{ item.updatedAt | getFormattedDate }}</h5>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon color="primary" small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon color="error" small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { gql } from 'apollo-boost';
import * as XLSX from 'xlsx';

// import { mapState } from 'vuex'
export default {
  data() {
    return {
      headers: [
        {
          text: 'Name',
          align: 'start',
          value: 'name',
        },
        {
          text: 'Description',
          align: 'start',
          value: 'description',
        },
        {
          text: 'Category',
          align: 'start',
          value: 'categoryName',
        },
        {
          text: 'Address',
          align: 'start',
          value: 'fullAddress',
        },
        {
          text: 'Coordinates',
          align: 'start',
          value: 'location',
        },
        { text: 'Created By', value: 'createdByUsername' },
        { text: 'Created Date', value: 'createdAt' },
        { text: 'Updated Date', value: 'updatedAt' },
        { text: 'Actions', align: 'right', sortable: false, value: 'actions' },
      ],
      search: '',
      locations: [],
      totalRecords: 0,
      isLoading: false,
      isExporting: false,
      dialog: false,
      options: null,
    };
  },
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    locations: {
      query: gql`
        query Locations($limit: Int!, $skip: Int!, $query: JSON!) {
          locations(limit: $limit, skip: $skip, query: $query) {
            records {
              id
              name
              description
              category
              categoryName
              fullAddress
              location
              createdByUsername
              createdBy
              createdAt
              updatedAt
            }
            count
          }
        }
      `,
      skip() {
        return !this.me || !this.options;
      },
      variables() {
        const self = this;
        const limit = self.options.itemsPerPage;
        const skip = (self.options.page - 1) * limit;
        const searchQuery = this.search;
        return {
          limit: limit,
          skip: skip,
          query: { searchQuery: searchQuery },
        };
      },
      result({ data }, key) {
        console.log('yeah data appeared', data);
        this.totalRecords = data.locations.count;
      },
      watchLoading(isLoading, countModifier) {
        this.isLoading = isLoading;
      },
    },
    allLocations: {
      query: gql`
        query AllLocations($query: JSON!) {
          allLocations(query: $query) {
            records {
              id
              name
              description
              category
              categoryName
              serviceType
              telephoneNumber
              emailAddress
              location
              fullAddress
              createdByUsername
              createdByRole
              createdBy
              ratingsCount
              averageRating
              createdAt
              updatedAt
            }
            count
          }
        }
      `,
      skip: true, // Skip automatic execution
      variables() {
        return {
          query: { searchQuery: '' },
        };
      },
    },
  },
  created() {
    // this.$eventHub.$on("refresh-invetory-item-view", this.refresh);
  },
  watch: {
    dialog(newValue, oldValue) {
      if (!newValue) {
        this.refresh();
      }
    },
  },
  methods: {
    editItem(item) {
      this.$router.push(`/admin/location/${item.id}/edit`);
    },
    deleteItem(item) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#b3a369',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then(async result => {
        if (result.value) {
          try {
            const response = await this.$apollo.mutate({
              mutation: gql`
                mutation($id: ID!) {
                  deleteLocation(id: $id) {
                    id
                    deleted
                  }
                }
              `,
              variables: {
                id: item.id,
              },
            });

            if (response) {
              this.$swal('Success!', 'Location was successfully deleted', 'success');
              this.$router.go(this.$route.currentRoute);
            }
          } catch (e) {
            console.log(`Deletion Failed ${JSON.stringify(e)}`);
          }
        }
      });
    },
    refresh() {
      this.$router.go(this.$route.currentRoute);
    },
    getCoordinates(item) {
      const coordinates = item && item.location && item.location.coordinates;
      if (!Array.isArray(coordinates) || coordinates.length < 2) return null;

      const longitude = Number(coordinates[0]);
      const latitude = Number(coordinates[1]);
      if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;

      return { latitude, longitude };
    },
    formatCoordinates(item) {
      const coordinates = this.getCoordinates(item);
      if (!coordinates) return '';

      return `${coordinates.latitude.toFixed(6)}, ${coordinates.longitude.toFixed(6)}`;
    },
    getGoogleMapsUrl(item) {
      const coordinates = this.getCoordinates(item);
      if (!coordinates) return '';

      return `https://www.google.com/maps/search/?api=1&query=${coordinates.latitude},${coordinates.longitude}`;
    },
    async exportToExcel() {
      try {
        this.isExporting = true;

        // Fetch all locations using the optimized allLocationsForExport query
        const response = await this.$apollo.query({
          query: gql`
            query AllLocationsForExport($query: JSON!) {
              allLocationsForExport(query: $query) {
                records {
                  id
                  name
                  description
                  category
                  serviceType
                  telephoneNumber
                  emailAddress
                  location
                  fullAddress
                  createdBy
                  createdAt
                  updatedAt
                }
                count
              }
            }
          `,
          variables: {
            query: { searchQuery: '' },
          },
        });

        const locations = response.data.allLocationsForExport.records;

        // Transform data for Excel export
        const excelData = locations.map(location => {
          // Parse location coordinates
          let latitude = '';
          let longitude = '';
          if (location.location && location.location.coordinates && Array.isArray(location.location.coordinates)) {
            longitude = location.location.coordinates[0] || '';
            latitude = location.location.coordinates[1] || '';
          }

          return {
            ID: location.id,
            Name: location.name || '',
            Description: location.description || '',
            'Category ID': location.category || '',
            'Service Type': location.serviceType || '',
            'Telephone Number': location.telephoneNumber || '',
            'Email Address': location.emailAddress || '',
            Latitude: latitude,
            Longitude: longitude,
            'Full Address': location.fullAddress || '',
            'Created By ID': location.createdBy || '',
            'Created Date': location.createdAt ? this.$moment(location.createdAt).format('YYYY-MM-DD HH:mm:ss') : '',
            'Updated Date': location.updatedAt ? this.$moment(location.updatedAt).format('YYYY-MM-DD HH:mm:ss') : '',
          };
        });

        // Create workbook and worksheet
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(excelData);

        // Auto-size columns
        const colWidths = [];
        const headers = Object.keys(excelData[0] || {});
        headers.forEach((header, index) => {
          const maxLength = Math.max(header.length, ...excelData.map(row => String(row[header] || '').length));
          colWidths[index] = { wch: Math.min(maxLength + 2, 50) };
        });
        ws['!cols'] = colWidths;

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, 'Locations');

        // Generate filename with current date
        const timestamp = this.$moment().format('YYYY-MM-DD_HH-mm-ss');
        const filename = `locations_export_${timestamp}.xlsx`;

        // Save file
        XLSX.writeFile(wb, filename);

        this.$swal('Success!', `Exported ${locations.length} locations to ${filename}`, 'success');
      } catch (error) {
        console.error('Export failed:', error);
        this.$swal('Error!', 'Failed to export locations. Please try again.', 'error');
      } finally {
        this.isExporting = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
